import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ListaComponent } from './lista/lista.component';
import { FormularioComponent } from './formulario/formulario.component';
import { HorarioDocenteComponent } from "./horario-docente/horario-docente.component";
import { HorarioDiarioComponent } from "./horario-diario/horario-diario.component";
import { AuthGuard } from '../../auth-guard.service';

const routes: Routes = [
  {
    path: "coordinacion-academica/horario",
    children: [
      { path: "lista", component: ListaComponent },
      { path: "nuevo", component: FormularioComponent },
      { path: "editar/:id", component: FormularioComponent },
      { path: "docente", component: HorarioDocenteComponent }
    ],
    canActivate: [AuthGuard]
  },
  {
    path: "coordinacion-academica/horario-docente",
    children: [{ path: "horario", component: HorarioDocenteComponent }],
    canActivate: [AuthGuard]
  },
  {
    path: "coordinacion-academica/horario-diario",
    children: [{ path: "horario", component: HorarioDiarioComponent }],
    canActivate: [AuthGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class HorarioRoutingModule { }

